(() => {
  if (window.apBloemCollectionCarousels) return;
  window.apBloemCollectionCarousels = true;

  function initialize(root = document) {
    root.querySelectorAll('.owl-carousel-bestsellers').forEach((element) => {
      if (element.dataset.carouselReady) return;
      element.dataset.carouselReady = 'true';
      const carousel = $(element);
      const requestedLimit = Math.max(0, Math.floor(Number(element.dataset.productLimit) || 0));
      const limit = Math.min(requestedLimit || 25000, 25000);
      let count = element.querySelectorAll('.item').length;
      let nextPage = element.dataset.customSort === 'true' ? 1 : 2;
      let more = nextPage === 1 || count < Math.min(Number(element.dataset.productCount), limit);
      let loading = false;

      carousel.owlCarousel({
        loop: true,
        margin: 15,
        lazyLoad: true,
        responsiveClass: true,
        autoplayHoverPause: true,
        dots: false,
        responsive: {
          0: { items: 2, nav: true, dots: false },
          600: { items: 4, nav: true },
          1000: { items: 4, nav: true, autoplay: false, loop: true },
        },
      });

      async function loadMore() {
        if (!more || loading || !element.dataset.collectionUrl) return;
        loading = true;
        element.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(element.dataset.collectionUrl, location.origin);
          url.searchParams.set('section_id', 'collection-carousel-page');
          url.searchParams.set('page', nextPage);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Unable to load collection products.');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const page = doc.querySelector('[data-carousel-page]');
          if (!page || Number(page.dataset.carouselPage) !== nextPage) throw new Error('Invalid collection page.');
          const items = [...page.querySelectorAll('.item')].slice(0, limit - count);
          const owl = carousel.data('owl.carousel');
          const position = count ? owl.relative(owl.current()) : 0;
          for (const item of items) carousel.trigger('add.owl.carousel', [item]);
          count += items.length;
          nextPage = Number(page.dataset.nextPage);
          more = nextPage > 0 && items.length > 0 && count < limit;
          carousel.trigger('refresh.owl.carousel');
          carousel.trigger('to.owl.carousel', [position, 0]);
          element.removeAttribute('data-load-error');
        } catch (error) {
          element.dataset.loadError = 'true';
          console.warn(error.message);
        } finally {
          loading = false;
          element.setAttribute('aria-busy', 'false');
        }
      }

      function nearEnd() {
        const owl = carousel.data('owl.carousel');
        if (owl && (count === 0 || owl.relative(owl.current()) + owl.settings.items >= count - 4)) loadMore();
      }
      carousel.on('changed.owl.carousel', (event) => {
        if (event.property?.name === 'position') nearEnd();
      });
      carousel.on('click', '.owl-next, .owl-prev', nearEnd);
      element.addEventListener('pointerenter', () => {
        if (element.dataset.loadError) nearEnd();
      });
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          if (nextPage === 1) loadMore();
        }
      }, { rootMargin: '300px' });
      observer.observe(element);
    });
  }

  $(initialize.bind(null, document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
